
import { Vue, Component, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import OrderService from '@/services/order.service';
import CarService from '@/services/car.service';
import OrderDrawer from '@/views/carModule/order/components/OrderDrawer.vue';

@Component({
  components: {
    OrderDrawer,
  },
})
export default class BOrderStatementDetails extends Vue {
  @lazyInject(OrderService)
  orderService!: OrderService;

  @lazyInject(CarService)
  carService!: CarService;

  @Ref('orderDrawer')
  orderDrawer!: OrderDrawer;

  tableData = [
    [{ name: '结算单号', enumeration: 'bill_no' }, { name: '结算日期', enumeration: 'settle_date' }, { name: '转账状态', enumeration: 'status' }],
    [{ name: '订单金额', enumeration: 'pay_amount', color: '#62b75e' }, { name: '退款金额', enumeration: 'refund_amount', color: '#e02924' }, { name: '平台手续费', enumeration: 'fee', color: '#e02924' }],
    [{ name: '转账金额', enumeration: 'settle_amount' }],
  ];

  billData = {};

  colimns = [
    {
      title: '序号',
      dataIndex: 'id',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80,
    },
    {
      title: '转账流水号',
      dataIndex: 'transfer_no',
      key: 'transfer_no',
      align: 'center',
      width: 240,
    },
    {
      title: '转账时间',
      dataIndex: 'transfer_success_time',
      key: 'transfer_success_time',
      align: 'center',
      width: 150,
    },
    {
      title: '转账金额',
      dataIndex: 'amount',
      key: 'amount',
      align: 'center',
      width: 150,
    },
    {
      title: '转账状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: 150,
      customRender: (text: any) => {
        // 0-待转账，1-转账成功，2-转账失败，3-待确认状态
        switch (text) {
          case 0:
            return '待转账';
          case 1:
            return '转账成功';
          case 2:
            return '转账失败';
          case 3:
            return '待确认状态';
        }
        return '';
      },
    },
    {
      title: '支付宝流水号',
      dataIndex: 'pay_order_no',
      key: 'pay_order_no',
      align: 'center',
      width: 200,
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      fixed: 'right',
      width: 120,
      scopedSlots: { customRender: 'action' },
    },
  ];

  recordsData = [];

  recordPagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onRecordShowSizeChange,
    onChange: this.onRecordChange,
  };

  orderPagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onOrderShowSizeChange,
    onChange: this.onOrderChange,
  };

  orderColimns = [
    {
      title: '序号',
      dataIndex: 'id',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80,
    },
    {
      title: '订单号',
      dataIndex: 'order_no',
      key: 'order_no',
      scopedSlots: { customRender: 'order_no' },
      align: 'center',
      width: 180,
    },
    {
      title: '城市',
      dataIndex: 'city',
      key: 'city',
      align: 'center',
      width: 150,
    },
    {
      title: '店铺名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
      width: 150,
    },
    {
      title: '店铺ID',
      dataIndex: 'shop_id',
      key: 'shop_id',
      align: 'center',
      width: 150,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: 150,
    },
    {
      title: '订单支付时间',
      dataIndex: 'pay_time',
      key: 'pay_time',
      align: 'center',
      width: 150,
    },
    {
      title: '订单金额',
      dataIndex: 'amount',
      key: 'amount',
      align: 'center',
      width: 150,
    },
  ];
  refundColimns = [
    {
      title: '序号',
      dataIndex: 'id',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80,
    },
    {
      title: '订单号',
      dataIndex: 'order_no',
      key: 'order_no',
      scopedSlots: { customRender: 'order_no' },
      align: 'center',
      width: 180,
    },
    {
      title: '城市',
      dataIndex: 'city',
      key: 'city',
      align: 'center',
      width: 100,
    },
    {
      title: '店铺名称',
      dataIndex: 'shopName',
      key: 'shopName',
      align: 'center',
      width: 160,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: 130,
    },
    {
      title: '订单金额',
      dataIndex: 'pay_price',
      key: 'pay_price',
      align: 'center',
      width: 100,
      customRender: (text: any) => {
        if (text) {
          return `${Number(text).toFixed(2)}`;
        }
        return '';
      },
    },
    {
      title: '支付时间',
      dataIndex: 'pay_time',
      key: 'pay_time',
      align: 'center',
      width: 160,
    },
    {
      title: '退款类型',
      dataIndex: 'refundType',
      key: 'refundType',
      align: 'center',
      width: 100,
    },
    {
      title: '退款金额',
      dataIndex: 'amount',
      key: 'amount',
      align: 'center',
      width: 100,
    },
    {
      title: '退款记录时间',
      dataIndex: 'refund_time',
      key: 'refund_time',
      align: 'center',
      width: 160,
    },
    {
      title: '退款记录人',
      dataIndex: 'refund_user',
      key: 'refund_user',
      align: 'center',
      width: 120,
    },
  ];

  activeKey = 1;

  billId = '';

  dataSource = [];

  onRecordChange(page: number) {
    this.recordPagination.current = page;
    this.getRecordsList();
  }
  onRecordShowSizeChange(current: number, pageSize: number) {
    this.recordPagination.current = current;
    this.recordPagination.pageSize = pageSize;
    this.getRecordsList();
  }

  onOrderChange(page: number) {
    this.orderPagination.current = page;
    this.getOrdersList();
  }
  onOrderShowSizeChange(current: number, pageSize: number) {
    this.orderPagination.current = current;
    this.orderPagination.pageSize = pageSize;
    this.getOrdersList();
  }
  callback(key: any) {
    this.activeKey = +key;
    this.dataSource = [];
    this.orderPagination.current = 1;
    this.orderPagination.pageSize = 10;
    this.getOrdersList();
  }
  mounted() {
    const { billId } = this.$route.params;
    this.billId = billId;
    this.getBillDetail(billId);
    this.getRecordsList();
    this.getOrdersList();
  }

  async getBillDetail(billId: any) {
    const res = await this.carService.getCarOrderSettlementBillDetail(billId);
    const status: any = {
      0: '待转账',
      1: '转账成功',
      2: '转账失败',
      3: '待确认状态',
    };
    this.billData = {
      ...res,
      status: status[res.status],
    };
  }

  async getRecordsList() {
    const params = {
      bill_id: this.billId,
      page: this.recordPagination.current,
      pageSize: this.recordPagination.pageSize,
    };
    const res = await this.carService.getCarOrderSettlementBillTransferRecords(params);
    this.recordsData = res.list;
    this.recordPagination.total = res.total;
  }

  async getOrdersList() {
    const params = {
      bill_id: this.billId,
      page: this.orderPagination.current,
      pageSize: this.orderPagination.pageSize,
    };
    if (this.activeKey === 1) {
      const res = await this.carService.getCarOrderSettlementBillOrders(params, this.$el);
      this.dataSource = res.list;
      this.orderPagination.total = res.total;
    } else {
      const res = await this.carService.getCarOrderRefundList(params, this.$el);
      if (res) {
        this.dataSource = res.list;
        this.orderPagination.total = res.total;
      }
    }
  }

  LookCOeder(orderId: string) {
    this.orderDrawer.init(orderId);
  }
  async reTransfer(record: any) {
    const res = await this.carService.postCarOrderSettlementRetry(record.transfer_no);

    if (res) {
      this.$message.success('操作成功');
      this.getRecordsList();
    }
  }
}
